// import React, { useEffect, useState } from "react";
// import { t } from "i18next";
// import axios from "axios";
// import { useDropzone } from "react-dropzone";
// import { FiUploadCloud, FiXCircle } from "react-icons/fi";
// import { notifyError, notifySuccess } from "../../utils/toast";
// import { DndProvider } from "react-dnd";
// import { HTML5Backend } from "react-dnd-html5-backend";
// import Container from "./Container";

// const UploaderAds = ({ setImageUrl, imageUrl, is_multiple, no_of_image, folder, name_merge, onImageUpload }) => {
//   const [files, setFiles] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [err, setError] = useState("");

//   const { getRootProps, getInputProps, fileRejections } = useDropzone({
//     accept: "image/jpeg, image/jpg, image/png, image/svg+xml",
//     multiple: is_multiple,

//     maxSize: 100000, // Max file size: 100 KB
//     maxFiles: no_of_image || 2,
//     onDrop: async (acceptedFiles) => {
//       const validFiles = [];

//       await Promise.all(
//         acceptedFiles.map((file) => {
//           return new Promise((resolve) => {
//             const img = new Image();
//             img.src = URL.createObjectURL(file);
//             img.onload = () => {
//               const width = img.naturalWidth;
//               const height = img.naturalHeight;
//               if (width >= 500 && width <= 600 && height >= 200 && height <= 250) {
//                 validFiles.push(
//                   Object.assign(file, {
//                     preview: URL.createObjectURL(file),
//                   })
//                 );
//                 resolve();
//               } else {
//                 notifyError(
//                   `Image dimensions must be between 500-600px (W) & 200-250px (H).`
//                 );
//                 resolve();
//               }
//             };
//           });
//         })
//       );

//       setFiles(validFiles); // Update state with valid files only
//     },
//   });

//   useEffect(() => {
//     if (fileRejections) {
//       fileRejections.map(({ file, errors }) => (
//         <li key={file.path}>
//           {file.path} - {file.size} bytes
//           <ul>
//             {errors.map((e) => (
//               <li key={e.code}>
//                 {e.code === "too-many-files"
//                   ? notifyError(`Maximum ${no_of_image ? no_of_image : 2} Image Can be Upload!`)
//                   : notifyError(e.message)}
//               </li>
//             ))}
//           </ul>
//         </li>
//       ));
//     }

//     if (files && files.length > 0) {
//       const imageUrlCount = Array.isArray(imageUrl) ? imageUrl.length : imageUrl ? 1 : 0;
//       if (
//         is_multiple === true &&
//         (imageUrlCount + files?.length) > no_of_image
//       ) {
//         return notifyError(`Maximum ${no_of_image ? no_of_image : 2} Image Can be Upload!`);
//       }

//       setLoading(true);
//       setError("Uploading....");
//       const formData = new FormData();
//       files.forEach((file, index) => {
//         formData.append("file", file);
//       });
//       formData.append("folderName", folder);
//       formData.append("name_merge", name_merge);

//       axios({
//         url: process.env.REACT_APP_API_BASE_URL + '/upload/' + ((files.length === 1) ? 'upload-single' : 'upload-multiple') + '/' + name_merge + '/' + folder,
//         method: "POST",
//         headers: {
//           "Content-Type": "multipart/form-data",
//         },
//         data: formData,
//       })
//         .then((res) => {
//           notifySuccess("Image Uploaded successfully!");
//           setLoading(false);
//           if (res && res.data.message !== "") {
//             if (files.length > 1) {
//               setImageUrl(res.data.image_path);
//             } else {
//               setImageUrl(res.data.image_path);
//             }
//             if (onImageUpload) {
//               onImageUpload(res.data.image_path); // Callback to send the image path back
//             }
//           }
//         })
//         .catch((err) => {
//           console.error("err", err);
//           notifyError(err.Message);
//           setLoading(false);
//         });
//     }
//             // eslint-disable-next-line 
//   }, [files]);

//   const thumbs = files.map((file) => (
//     <div key={file.name}>
//       <div>
//         <img
//           className="inline-flex border-2 border-gray-100 w-24 max-h-24"
//           src={file.preview}
//           alt={file.name}
//         />
//       </div>
//     </div>
//   ));

//   useEffect(
//     () => () => {
//       files.forEach((file) => URL.revokeObjectURL(file.preview));
//     },
//     [files]
//   );

//   const handleRemoveImage = async (img) => {
//     const segments = img.split('/');
//     const imageName = segments[segments.length - 1];
//     const image_path = `${folder}/${imageName}`;
//     axios({
//       url: process.env.REACT_APP_API_BASE_URL + '/upload/delete',
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       data: { image_path },
//     })
//       .then((res) => {
//         setLoading(false);
//         notifyError(
//           res.data.data === "ok" ? "Image deleted successfully!" : res.data.data
//         );

//         if ((is_multiple === true && files.length > 1) || (Array.isArray(imageUrl) && imageUrl.length > 1)) {
//           const result = imageUrl?.filter((i) => i !== image_path);
//           setImageUrl(result);
//         }
//         else if (is_multiple === true && (files.length === 1 || Array.isArray(imageUrl))) {
//           setImageUrl([]);
//         } else {
//           setImageUrl("");
//         }
//       })
//       .catch((err) => {
//         console.error("err", err);
//         notifyError(err.Message);
//         setLoading(false);
//       });
//   };

//   return (
//     <div className="w-full text-center">
//       {/* {!((is_multiple && (files.length > 0 || Array.isArray(imageUrl) && imageUrl.length > 0)) || (!is_multiple && (imageUrl || files.length > 0))) && (


//         <div
//           className="border-2 border-gray-300 dark:border-gray-600 border-dashed rounded-md cursor-pointer px-6 pt-5 pb-6"
//           {...getRootProps()}
//         >
//           <input {...getInputProps()} />
//           <span className="mx-auto flex justify-center">
//             <FiUploadCloud className="text-3xl text-green-500" />
//           </span>
//           <p className="text-sm mt-2">{t("DragYourImage")}</p>
//           <em className="text-xs text-gray-400">{t("imageFormat")}</em>
//         </div>
//       )} */}
//       {!(
//   (
//     is_multiple &&
//     (
//       files.length > 0 || (Array.isArray(imageUrl) && imageUrl.length > 0)
//     )
//   ) || 
//   (
//     !is_multiple &&
//     (imageUrl || files.length > 0)
//   )
// ) && (
//   <div
//     className="border-2 border-gray-300 dark:border-gray-600 border-dashed rounded-md cursor-pointer px-6 pt-5 pb-6"
//     {...getRootProps()}
//   >
//     <input {...getInputProps()} />
//     <span className="mx-auto flex justify-center">
//       <FiUploadCloud className="text-3xl text-green-500" />
//     </span>
//     <p className="text-sm mt-2">{t("DragYourImage")}</p>
//     <em className="text-xs text-gray-400">{t("imageFormat")}</em>
//   </div>
// )}

//       <div className="mt-4 text-xs text-gray-500">
//         <p>
//           Max file size: 70-100 KB. Image dimensions must be between 500-600px (W) & 200-250px (H).
//         </p>
//       </div>
//       <div className="text-green-500">{loading && err}</div>
//       <aside className="flex flex-row flex-wrap mt-4">
//         {(is_multiple && files.length > 1) || (Array.isArray(imageUrl) && imageUrl.length > 0) ? (
//           <DndProvider backend={HTML5Backend}>
//             <Container
//               setImageUrl={setImageUrl}
//               imageUrl={imageUrl}
//               handleRemoveImage={handleRemoveImage}
//             />
//           </DndProvider>
//         ) : (!is_multiple && (imageUrl || files.length === 1)) ? (
//           <div className="relative">
//             <img
//               className="inline-flex border rounded-md border-gray-100 dark:border-gray-600 w-24 max-h-24 p-2"
//               src={imageUrl || (files[0] && files[0].preview)}
//               alt="Preview"
//             />
//             <button
//               type="button"
//               className="absolute top-0 right-0 text-red-500 focus:outline-none"
//               onClick={() => handleRemoveImage(imageUrl || files[0]?.preview)}
//             >
//               <FiXCircle />
//             </button>
//           </div>
//         ) : (
//           thumbs
//         )}
//       </aside>
//     </div>
//   );
// };

// export default UploaderAds;





import React, { useEffect, useState } from "react";
import { t } from "i18next";
import axios from "axios";
import { useDropzone } from "react-dropzone";
import { FiUploadCloud, FiXCircle } from "react-icons/fi";
import { notifyError, notifySuccess } from "../../utils/toast";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import Container from "./Container";

const UploaderAds = ({
  setImageUrl,
  imageUrl,
  is_multiple,
  no_of_image,
  folder,
  name_merge,
  onImageUpload,
}) => {
  const isTrustedCompany = folder === "trusted-companies";

  const maxFileSize = isTrustedCompany
    ? 5 * 1024 * 1024
    : 100 * 1024;

  const minWidth = isTrustedCompany ? 200 : 500;
  const maxWidth = isTrustedCompany ? 350 : 600;

  const minHeight = isTrustedCompany ? 60 : 200;
  const maxHeight = isTrustedCompany ? 80 : 250;

  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setError] = useState("");


  const { getRootProps, getInputProps, fileRejections } = useDropzone({
    accept: "image/jpeg, image/jpg, image/png, image/svg+xml",
    multiple: is_multiple,
    maxSize: maxFileSize,
    maxFiles: no_of_image || 2,

    onDrop: async (acceptedFiles) => {
      const validFiles = [];

      await Promise.all(
        acceptedFiles.map((file) => {
          return new Promise((resolve) => {
            const objectUrl = URL.createObjectURL(file);
            const img = new Image();

            img.onload = () => {
              const width = img.naturalWidth;
              const height = img.naturalHeight;

              if (
                width >= minWidth &&
                width <= maxWidth &&
                height >= minHeight &&
                height <= maxHeight
              ) {
                validFiles.push(
                  Object.assign(file, {
                    preview: objectUrl,
                  })
                );
              } else {
                URL.revokeObjectURL(objectUrl);

                notifyError(
                  `Image dimensions must be between ${minWidth}-${maxWidth}px (W) and ${minHeight}-${maxHeight}px (H).`
                );
              }

              resolve();
            };

            img.onerror = () => {
              URL.revokeObjectURL(objectUrl);
              notifyError("Unable to read the selected image.");
              resolve();
            };

            img.src = objectUrl;
          });
        })
      );

      setFiles(validFiles);
    },
  });


  useEffect(() => {
    if (fileRejections?.length > 0) {
      fileRejections.forEach(({ file, errors }) => {
        errors.forEach((error) => {
          if (error.code === "file-too-large") {
            notifyError(
              `Maximum file size is ${isTrustedCompany ? "5 MB" : "100 KB"}.`
            );
          } else if (error.code === "too-many-files") {
            notifyError(
              `Maximum ${no_of_image || 2} image(s) can be uploaded.`
            );
          } else {
            notifyError(error.message);
          }
        });
      });
    }
  }, [fileRejections, isTrustedCompany, no_of_image]);

  useEffect(() => {
    if (!files.length) {
      return;
    }

    const imageUrlCount = Array.isArray(imageUrl)
      ? imageUrl.length
      : imageUrl
        ? 1
        : 0;

    if (
      is_multiple &&
      imageUrlCount + files.length > (no_of_image || 2)
    ) {
      notifyError(
        `Maximum ${no_of_image || 2} image(s) can be uploaded.`
      );
      setFiles([]);
      return;
    }

    const uploadFiles = async () => {
      setLoading(true);
      setError("Uploading...");

      try {
        const formData = new FormData();

        files.forEach((file) => {
          formData.append("file", file);
        });

        formData.append("folderName", folder);
        formData.append("name_merge", name_merge);

        const endpoint =
          files.length === 1 ? "upload-single" : "upload-multiple";

        const res = await axios({
          url:
            `${process.env.REACT_APP_API_BASE_URL}/upload/${endpoint}/${name_merge}/${folder}`,
          method: "POST",
          headers: {
            "Content-Type": "multipart/form-data",
          },
          data: formData,
        });

        if (res?.data?.image_path) {
          setImageUrl(res.data.image_path);

          if (onImageUpload) {
            onImageUpload(res.data.image_path);
          }

          notifySuccess("Image uploaded successfully!");
        } else {
          notifyError("Image upload failed. No image path returned.");
        }
      } catch (error) {
        notifyError(
          error?.response?.data?.message ||
          error?.message ||
          "Image upload failed."
        );
      } finally {
        setLoading(false);
        setError("");
      }
    };

    uploadFiles();
  }, [files]);

  useEffect(() => {
    return () => {
      files.forEach((file) => {
        if (file.preview) {
          URL.revokeObjectURL(file.preview);
        }
      });
    };
  }, [files]);

  const handleRemoveImage = async (img) => {
    if (!img) {
      return;
    }

    const segments = img.split("/");
    const imageName = segments[segments.length - 1];
    const imagePath = `${folder}/${imageName}`;

    try {
      setLoading(true);

      const res = await axios({
        url: `${process.env.REACT_APP_API_BASE_URL}/upload/delete`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          image_path: imagePath,
        },
      });

      if (res?.data?.data === "ok") {
        notifySuccess("Image deleted successfully!");

        if (
          is_multiple &&
          (files.length > 1 ||
            (Array.isArray(imageUrl) && imageUrl.length > 1))
        ) {
          const result = (Array.isArray(imageUrl) ? imageUrl : []).filter(
            (item) => item !== imagePath
          );

          setImageUrl(result);
        } else if (is_multiple) {
          setImageUrl([]);
        } else {
          setImageUrl("");
        }

        setFiles((previousFiles) =>
          previousFiles.filter(
            (file) =>
              file.preview !== img &&
              file.name !== imageName
          )
        );
      } else {
        notifyError(res?.data?.data || "Unable to delete image.");
      }
    } catch (error) {
      notifyError(
        error?.response?.data?.message ||
        error?.message ||
        "Image deletion failed."
      );
    } finally {
      setLoading(false);
    }
  };

  const thumbs = files.map((file) => (
    <div key={`${file.name}-${file.lastModified}`}>
      <img
        className="inline-flex border-2 border-gray-100 w-24 max-h-24 object-contain"
        src={file.preview}
        alt={file.name}
      />
    </div>
  ));

  const hasMultipleImages =
    (is_multiple && files.length > 1) ||
    (Array.isArray(imageUrl) && imageUrl.length > 0);

  const hasSingleImage =
    !is_multiple && (imageUrl || files.length > 0);

  return (
    <div className="w-full text-center">
      {!hasMultipleImages && !hasSingleImage && (
        <div
          className="border-2 border-gray-300 dark:border-gray-600 border-dashed rounded-md cursor-pointer px-6 pt-5 pb-6"
          {...getRootProps()}
        >
          <input {...getInputProps()} />

          <span className="mx-auto flex justify-center">
            <FiUploadCloud className="text-3xl text-green-500" />
          </span>

          <p className="text-sm mt-2">{t("DragYourImage")}</p>
          <em className="text-xs text-gray-400">
            {t("imageFormat")}
          </em>
        </div>
      )}

      <div className="mt-4 text-xs text-gray-500">
        <p>
          Maximum file size: {isTrustedCompany ? "5 MB" : "100 KB"}.
        </p>
        <p>
          {/* Image dimensions: {minWidth}-{maxWidth}px (W) ×{" "}
          {minHeight}-{maxHeight}px (H). */}
          Image dimensions: {maxWidth}px (W) ×{" "}
          {maxHeight}px (H).
        </p>
      </div>

      <div className="text-green-500">
        {loading && err}
      </div>

      <aside className="flex flex-row flex-wrap mt-4">
        {hasMultipleImages ? (
          <DndProvider backend={HTML5Backend}>
            <Container
              setImageUrl={setImageUrl}
              imageUrl={imageUrl}
              handleRemoveImage={handleRemoveImage}
            />
          </DndProvider>
        ) : hasSingleImage ? (
          <div className="relative">
            <img
              className="inline-flex border rounded-md border-gray-100 dark:border-gray-600 w-24 h-24 object-contain p-2"
              src={
                imageUrl ||
                (files[0] && files[0].preview)
              }
              alt="Preview"
            />

            <button
              type="button"
              className="absolute top-0 right-0 text-red-500 focus:outline-none"
              onClick={() =>
                handleRemoveImage(
                  imageUrl || files[0]?.preview
                )
              }
            >
              <FiXCircle />
            </button>
          </div>
        ) : (
          thumbs
        )}
      </aside>
    </div>
  );
};

export default UploaderAds;
